import { categoryOfType, PROFILE_CATEGORY_META } from '@shared/constants/profile-categories';

/** What a stored type label reads as on screen: its category's name, or itself. */
export function typeDisplayName(label: string): string {
  const category = categoryOfType(label);
  return category ? PROFILE_CATEGORY_META[category].singular : label;
}

/** How many type chips a profile shows before "+N" (#642). */
export const MAX_SHOWN_TYPES = 3;

export interface ShownTypes {
  /** The stored labels to draw as chips, most important first. */
  shown: string[];
  /** The display names left out, in priority order: the "+N" tooltip. */
  hidden: string[];
  /** Every display name, in priority order: what a truncated row spells out. */
  all: string[];
}

/**
 * The chips a profile's types make (#642): up to `max`, in the order `types`
 * arrives in: priority order, kept so by the database trigger. The first one is
 * the primary type.
 *
 * One chip per display name, not per stored label: a profile tagged both "FO"
 * and "SFO" is a Family Office once, and two "Family Office" chips (or a "+1
 * Family Office" beside one) would announce something the row is not hiding.
 */
export function shownTypes(types: readonly string[], max = MAX_SHOWN_TYPES): ShownTypes {
  const firstLabelPerName = new Map<string, string>();
  for (const label of types) {
    const name = typeDisplayName(label);
    if (!firstLabelPerName.has(name)) firstLabelPerName.set(name, label);
  }
  const entries = [...firstLabelPerName.entries()];
  return {
    shown: entries.slice(0, max).map(([, label]) => label),
    hidden: entries.slice(max).map(([name]) => name),
    all: entries.map(([name]) => name),
  };
}
